
import VerificationFailed from "./VerificationFailed";
import Footer from '../../components/Footer';
import IBVGuidsReport from "./IBVGuidsReport";

const Subscribers: React.FC = () => {
    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-sm-12">
                    <div className="main-container">
                        <div className="main-container-inner">
                            <div className="main-card revrex-data-table-card">
                                <div className='d-flex justify-content-between align-items-center mb-3'>
                                    <h1 className='page-title-sm'>IBV Account Verification Failed</h1>
                                </div>
                                <IBVGuidsReport />
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Subscribers;